import { faAngleRight, faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

export const RecruitmentRow = ({
  name,
  id,
  uuid,
  salary1,
  salary2,
  address1,
  address2,
  qty,
  date_refresh,
  fairId,
}) => {
  return (
    <div className="row">
      <div className="col">
        <div className="pull-left">
          <strong>{name}</strong>
        </div>
        <div className="pull-right">
          <a
            style={{ fontSize: 14 }}
            className="badge badge-pill badge-info"
            href={`#/岗位/${id}?fairId=${fairId}&u_id=${uuid}`}
          >
            查看
          </a>
        </div>
        <br />
        <span className="text-success">
          {salary1 && salary2 ? `${salary1}-${salary2}` : "面议"}
        </span>
        {salary1 && salary2 ? "元/月" : ""}
        <br />
        <span className="pull-left text-muted" style={{ fontSize: 11 }}>
          {address1}-{address2}
          |人数:
          {qty}
        </span>
        <span className="pull-right text-muted" style={{ fontSize: 11 }}>
          {moment(date_refresh).format("YYYY-MM-DD")}
        </span>
      </div>
    </div>
  );
};

RecruitmentRow.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  uuid: PropTypes.string.isRequired,
  address1: PropTypes.string.isRequired,
  address2: PropTypes.string.isRequired,
  qty: PropTypes.string.isRequired,
  date_refresh: PropTypes.string.isRequired,
  salary1: PropTypes.number.isRequired,
  salary2: PropTypes.number.isRequired,
  education: PropTypes.string,
  fairId: PropTypes.string,
};

RecruitmentRow.defaultProps = {
  education: undefined,
};

export const RecruitmentRow1 = ({
  name,
  id,
  uuid,
  salary1,
  salary2,
  address1,
  address2,
  education,
  qty,
  refreshTime,
  fairId,
}) => {
  return (
    <div className="row">
      <div className="col">
        <a
          href={`#/岗位/${id}?fairId=${fairId}&u_id=${uuid}`}
          style={{ color: "#202529", textDecoration: "none" }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-hidden">
              <strong>{name}</strong>
            </div>
            <div>
              <span style={{ fontSize: 14 }} className="badge badge-pill badge-info">
                查看
              </span>
            </div>
          </div>
          <br />
          <span className="text-success">
            {salary1 !== "0" && salary2 !== "0" ? `${salary1}-${salary2}` : "面议"}
          </span>
          {salary1 !== "0" && salary2 !== "0" ? "元/月" : ""}
          <br />
          <div className="d-flex flex-row justify-content-between">
            <div className="d-flex flex-row">
              {address1 && (
                <span className="text-muted mr-2" style={{ fontSize: 11 }}>
                  {address1} {address2}
                </span>
              )}
              {education && (
                <span className="text-muted mr-2" style={{ fontSize: 11 }}>
                  {education}
                </span>
              )}
              {qty && (
                <span className="text-muted mr-2" style={{ fontSize: 11 }}>
                  招聘人数: {qty}
                </span>
              )}
            </div>
            <div className="">
              <span className="pull-right text-muted" style={{ fontSize: 11 }}>
                {dayjs(refreshTime).format("YYYY-MM-DD")}
              </span>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};

RecruitmentRow1.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  uuid: PropTypes.string.isRequired,
  addressLevel1: PropTypes.string.isRequired,
  addressLevel2: PropTypes.string.isRequired,
  qty: PropTypes.string.isRequired,
  refreshTime: PropTypes.string.isRequired,
  salary1: PropTypes.string.isRequired,
  salary2: PropTypes.string.isRequired,
  education: PropTypes.string,
  fairId: PropTypes.string,
};

RecruitmentRow1.defaultProps = {
  education: undefined,
};

export const RecruitRow = ({ name, id, uuid, address2, address3, date, enterprise_name }) => (
  <div className="row">
    <div className="col">
      <div className="pull-left">
        <strong>{name}</strong>
      </div>
      <div className="pull-right">
        <a href={`#/校园招聘/${id}?u_id=${uuid}`}>
          详情
          <FontAwesomeIcon icon={faAngleRight} size="lg" fixedWidth />
        </a>
      </div>
      <br />
      <span className="text-muted" style={{ fontSize: 11 }}>
        举办地点:
        {address2}-{address3}
        <br />
        开始时间:
        {date}
      </span>
      <br />
      <span>{enterprise_name}</span>
    </div>
  </div>
);

RecruitRow.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  uuid: PropTypes.string.isRequired,
  address2: PropTypes.string.isRequired,
  address3: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  enterprise_name: PropTypes.string,
};

RecruitRow.defaultProps = {
  enterprise_name: "",
};

export const RecruitRow1 = ({
  title,
  id,
  uuid,
  address_level2,
  address_level3,
  date,
  school,
  category,
}) => (
  <div className="row">
    <div className="col">
      <div className="pull-left">
        <strong>{title}</strong>
      </div>
      <div className="pull-right">
        <a href={`#/校园招聘/${id}?u_id=${uuid}`}>
          详情
          <FontAwesomeIcon icon={faAngleRight} size="lg" fixedWidth />
        </a>
      </div>
      <br />
      <span className="text-muted" style={{ fontSize: 11 }}>
        举办地点:
        {address_level2}-{address_level3}
        <br />
        开始时间:
        {date}
      </span>
      <br />
      <span>
        {school}({category})
      </span>
      <hr />
    </div>
  </div>
);

RecruitRow1.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  uuid: PropTypes.string.isRequired,
  address_level2: PropTypes.string.isRequired,
  address_level3: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  school: PropTypes.string.isRequired,
};

export const RecommendRow = ({
  title,
  id,
  uuid,
  address_level1,
  address_level2,
  qty,
  enterprise_name,
}) => (
  <div className="row">
    <div className="col">
      <div className="pull-left">
        <strong>{title}</strong>
      </div>
      <div className="pull-right">
        <a href={`#主页/消息详情/${id}?u_id=${uuid}`}>
          详情
          <FontAwesomeIcon icon={faAngleRight} size="lg" fixedWidth />
        </a>
      </div>
      <br />
      <span className="text-muted" style={{ fontSize: 11 }}>
        工作地点：
        {address_level1}-{address_level2}
        |人数:
        {qty}
      </span>
      <br />
      <span>{enterprise_name}</span>
    </div>
  </div>
);

RecommendRow.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  uuid: PropTypes.string.isRequired,
  address_level1: PropTypes.string.isRequired,
  address_level2: PropTypes.string.isRequired,
  qty: PropTypes.string.isRequired,
  enterprise_name: PropTypes.string,
};

RecommendRow.defaultProps = {
  enterprise_name: "",
};

export const RecommendRow1 = ({
  title,
  id,
  uuid,
  address_level1,
  address_level2,
  qty,
  publisher,
}) => (
  <>
    <div className="row">
      <div className="col">
        <a
          href={`#主页/消息详情/${id}?u_id=${uuid}`}
          style={{ color: "#202529", textDecoration: "none" }}
        >
          <div className="row">
            <div className="col text-hidden">
              <strong>{title}</strong>
            </div>
          </div>
          <span className="text-muted pull-left">
            工作地点:
            {address_level1}-{address_level2}
            |人数:
            {qty}
          </span>
          <div className="pull-right ">
            <span style={{ color: "#00a4ff" }}>
              <FontAwesomeIcon icon={faChevronCircleRight} size="lg" fixedWidth />
            </span>
          </div>
          <br />
          <span>{publisher}</span>
        </a>
      </div>
    </div>
    <hr style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }} />
  </>
);

RecommendRow1.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  uuid: PropTypes.string.isRequired,
  address_level1: PropTypes.string.isRequired,
  address_level2: PropTypes.string.isRequired,
  qty: PropTypes.string.isRequired,
  publisher: PropTypes.string.isRequired,
};
